module.exports = __webpack_public_path__ + "img/1.eb20db59.png";